export const freeShippingIv = (values) => {
    return {
        id: values.id,
        carrier_name: values.carrier_name || "",
        shipping_type: values.shipping_type || "",
        shipping_name: values.shipping_name || "",
        description_for_customer: values.description_for_customer || "",
        minimum_order_subtotal: values.minimum_order_subtotal || "",
        estimated_transit_time_from: values.estimated_transit_time_from || "",
        estimated_transit_time_to: values.estimated_transit_time_to || "",
        order_preparation_time: values.order_preparation_time || "",
        custom_time_frame_from: values.custom_time_frame_from || "",
        custom_time_frame_to: values.custom_time_frame_to || "",
        orders_received_past_this_time_on_the_next_day: values.orders_received_past_this_time_on_the_next_day || "",
        days_when_you_pack_orders: values.days_when_you_pack_orders || "",
        shipping_region: values.shipping_region || "",
        zone: values.zone || "",
        status: values.status || 1,
        amount: values.amount || "",
        amount_type: values.amount_type || ""
    }
}

export const freeShippinVS_ = (values) => {
    const errors = {}
    if (!values.shipping_name) {
        errors.shipping_name = "This field is required"
    }
    if (!values.description_for_customer) {
        errors.description_for_customer = "This field is required"
    }
    if (!values.minimum_order_subtotal) {
        errors.minimum_order_subtotal = "This field is required"
    }
    if (!values.order_preparation_time) {
        errors.order_preparation_time = "This field is required"
    }
    if (!values.orders_received_past_this_time_on_the_next_day) {
        errors.orders_received_past_this_time_on_the_next_day = "This field is required"
    }
    if (!values.shipping_region) {
        errors.shipping_region = "This field is required"
    }

    if (!values.estimated_transit_time_from) {
        errors.estimated_transit_time_from = "This field is required"
    } else if (parseInt(values.estimated_transit_time_from) < 1) {
        errors.estimated_transit_time_from = "Invalid"
    }

    if (!values.estimated_transit_time_to) {
        errors.estimated_transit_time_to = "This field is required"
    } else if (parseInt(values.estimated_transit_time_to) < 1) {
        errors.estimated_transit_time_to = "Invalid"
    }

    if (values.estimated_transit_time_from && values.estimated_transit_time_to &&
        parseInt(values.estimated_transit_time_from) >= parseInt(values.estimated_transit_time_to)) {
        errors.estimated_transit_time_to = "invalid"
    }
    if (values.shipping_type === "flat_rate" && !values.amount) {
        errors.amount = "Required"
    }
    if (values.shipping_type === "flat_rate" && !values.amount_type) {
        errors.amount_type = "Required"
    }

    return errors
}

